import type { Dayjs } from "dayjs";

import dayjs from "@/utils/dayjs";

interface HotelGuestInterface {
  title: string;
  firstname: string;
  lastname: string;
  smoking: number;
  countryOfPassport: string;
}

export interface RequestHotelAllocateInterface {
  roomKey: string;
  contactTitle: string; // Supports only Ms and Mr
  contactFirstname: string; // Type String, Supports aA-zZ
  contactLastname: string; // Type String, Supports aA-zZ
  contactEmail: string; // Type Email
  contactPhone: string; // Type Numeric
  "guest[title]": string; // Type String, Supports only Ms and Mr
  "guest[firstname]": string; // Type String, Supports aA-zZ
  "guest[lastname]": string; // Type String, Supports aA-zZ
  "guest[smoking]": string; // Type Boolean, "0" or "1"
  "guest[countryOfPassport]": string; // ISO code 2a, ex: TH, US, UK, etc.
  specialRequest?: string; // Type String (Optional)
  preferredCurrency?: string; // Optional for Gother Only
  url_callback_unsuccess: string;
  itemListName?: string;
  totalRoom: number;
  totalAdult: number;
  totalChild: number;
  childAge?: string;
  couponCode?: string;
  buyNowPayLater: number;
  ga4Data?: string;
  _fbp?: string;
  _fbc?: string;
  ttclid?: string;
  _ttp?: string;
}

export class ResponseHotelAllocate {
  bookingInternalNo: string;

  code: string;

  message: string;

  status: boolean;

  rsvnId: number;

  expired: Dayjs;

  price: {
    amount: number;
    currency: string;
  };

  pricechanged: any; // You might want to define a specific type for this property

  cancellationPolicyChanged: {
    isChange: boolean;
    cancellationPolicy: {
      date: string;
      chargeType: string;
      chargeAmount: number;
      currency: string;
    }[];
    cancellationPolicyDetail: string[];
    payAtHotelcancellationPolicy: any; // You might want to define a specific type for this property
    payAtHotelcanCellationPolicyDetail: any[]; // You might want to define a specific type for this property
    freeCancellation: number;
    remark: any[]; // You might want to define a specific type for this property
    alert: string[];
  };

  payAtHotel: boolean;

  paymentUrl: string;

  constructor(data: any) {
    this.bookingInternalNo = data?.bookingInternalNo || "";
    this.code = data?.code || "";
    this.message = data?.message || "";
    this.status = data?.status || true;
    this.rsvnId = data?.rsvnId || 0;
    this.expired = dayjs(data?.expired) || "";
    this.price = {
      amount: data?.price?.amount || 0,
      currency: data?.price?.currency || "",
    };
    this.pricechanged = data?.pricechanged;
    this.cancellationPolicyChanged = {
      isChange: data?.cancellationPolicyChanged?.isChange || false,
      cancellationPolicy:
        data?.cancellationPolicyChanged?.cancellationPolicy || [],
      cancellationPolicyDetail:
        data?.cancellationPolicyChanged?.cancellationPolicyDetail || [],
      payAtHotelcancellationPolicy:
        data?.cancellationPolicyChanged?.payAtHotelcancellationPolicy,
      payAtHotelcanCellationPolicyDetail:
        data?.cancellationPolicyChanged?.payAtHotelcanCellationPolicyDetail ||
        [],
      freeCancellation: data?.cancellationPolicyChanged?.freeCancellation || 0,
      remark: data?.cancellationPolicyChanged?.remark || [],
      alert: data?.cancellationPolicyChanged?.alert || [],
    };
    this.payAtHotel = data?.payAtHotel || false;
    this.paymentUrl = data?.paymentUrl || "";
  }
}
